import {
  Avatar,
  Badge,
  Card,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TablePagination,
  TableRow,
  Stack,
  Typography,
  Tooltip,
  ListItemText,
} from '@mui/material';
import { useEffect, useState } from 'react';
import DeleteIcon from '@mui/icons-material/Delete';
import { styled } from '@mui/system';
import CRMToolbar from './crmToolBar';
import ConfirmationDialog from 'src/components/ConfirmationDialog';
import HttpServices from 'src/services/httpService';
import { crmModuleURL } from 'src/services/urlService';
import Spinner from 'src/utils/Loader/spinner';
import { useToaster } from 'src/utils/toaster/toasterContext';
import NoPostFound from 'src/pages/publishedPosts/noPost.component';
import Facebook from '../../../assets/facebook.svg';
import GBusiness from '../../../assets/google-my-business-logo.svg';
import Instagram from '../../../assets/instagram.svg';
import LinkedIn from '../../../assets/linked_in.svg';
import Pinterest_Icon from '../../../assets/pinterest-icon.svg';
import Tiktok from '../../../assets/tiktok.svg';
import Twitter from '../../../assets/twitter.svg';
import YouTube from '../../../assets/youtube_social_icon_red 128px.png';
import { StyledComponent } from 'src/components/styled-components/styledComponent';
import { UserListHead } from 'src/sections/@dashboard/user';
import { CommonHelper } from 'src/utils/commonHelper';
import { PostDetailsHelper } from 'src/utils/postDetailsHelper';
import { useTranslation } from 'react-i18next';

const CRMAccounts = ({ isShowOfferBanner=false }) => {
  const { t: translate } = useTranslation();
  const [crmAccounts, setCRMAccounts] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [height, setHeight] = useState(window.innerHeight - 250);
  const [loader, setLoader] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [accountToDelete, setAccountToDelete] = useState(null);

  const { showToast } = useToaster();

  useEffect(() => {
    getAllCRMAccounts();
  }, []);

  const getAllCRMAccounts = () => {
    setLoader(true);
    HttpServices.Get({
      url: crmModuleURL.getCRMAccounts,
      successCallback: (data) => {
        setCRMAccounts(data);
        setLoader(false);
      },
      failureCallback: (message) => {
        setLoader(false);
        showToast(message, 'e');
      },
    });
  };

  const handleDeleteAccount = () => {
    HttpServices.Post({
      url: crmModuleURL.deleteWebhookAccounts,
      body: {
        connected_profile_id: accountToDelete?.connected_profile_details.connected_profile_id,
        service_name: accountToDelete?.connected_profile_details.social_media,
      },
      successCallback: () => {
        showToast(`${translate('crm.account_deleted_success')}`, 's');
        setConfirmOpen(false);
        getAllCRMAccounts();
      },
      failureCallback: (message) => {
        showToast(message, 'e');
        setConfirmOpen(false);
      },
    });
  };

  const handleAccountStatus = (row) => {
    const url = row.is_enabled ? crmModuleURL.disableWebhookAccounts : crmModuleURL.enableWebhookAccounts;

    HttpServices.Post({
      url,
      body: {
        connected_profile_id: row?.connected_profile_details.connected_profile_id,
        service_name: row?.connected_profile_details.social_media,
      },
      successCallback: () => {
        showToast(`${translate('crm.account_status_updated_success')}`, 's');
        getAllCRMAccounts();
      },
      failureCallback: (message) => {
        showToast(message, 'e');
      },
    });
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const getAvatar = (service_name) => {
    switch (service_name) {
      case 'twitter':
        return <SmallAvatar_t alt="twitter" src={Twitter} />;
      case 'facebook':
        return <SmallAvatar_f alt="facebook" src={Facebook} />;
      case 'youtube':
        return <img alt="youtube" src={YouTube} />;
      case 'pinterest':
        return <img alt="youtube" src={Pinterest_Icon} />;
      case 'instagram':
        return <SmallAvatar_i alt="instagram" src={Instagram} />;
      case 'gbusiness':
        return <SmallAvatar_g alt="gbusiness" src={GBusiness} variant="rounded" />;
      case 'linkedin':
        return <SmallAvatar_l alt="linkedin" src={LinkedIn} variant="rounded" />;
      case 'tiktok':
        return <SmallAvatar_l alt="linkedin" src={Tiktok} />;
      default:
        return null;
    }
  };
  //Styled Components
  const SmallAvatar_f = styled(Avatar)(({}) => ({
    width: 20,
    height: 20,
    overflow: 'hidden',
    backgroundColor: '#ffffff',
  }));

  const SmallAvatar_i = styled(Avatar)(({}) => ({
    width: 20,
    height: 20,
    overflow: 'hidden',
  }));
  const SmallAvatar_g = styled(Avatar)(({}) => ({
    width: 23,
    height: 23,
    overflow: 'hidden',
  }));

  const SmallAvatar_t = styled(Avatar)(({}) => ({
    width: 20,
    height: 20,
    backgroundColor: '#ffffff',
  }));

  const SmallAvatar_l = styled(Avatar)(({}) => ({
    width: 23,
    height: 23,
    overflow: 'hidden',
  }));

  return (
    <>
      {loader ? (
        <Spinner />
      ) : (
        <Card sx={{ m: 1 }}>
          <CRMToolbar handleRefreshGrid={getAllCRMAccounts} />
          {crmAccounts.length > 0 ? (
            <TableContainer sx={{ height: isShowOfferBanner ? 'calc(100vh - 355px)' : 'calc(100vh - 305px)' }}>
              <Table stickyHeader>
                <UserListHead
                  headLabel={[
                    { id: 'profile', label: translate('crm.profile', 'Profile'), alignRight: false },
                    { id: 'createdAt', label: translate('crm.created_at', 'Created At'), alignRight: false },
                    { id: 'updatedAt', label: translate('crm.updated_at', 'Updated At'), alignRight: false },
                    { id: 'createdBy', label: translate('crm.created_by', 'Created By'), alignRight: false },
                    { id: 'status', label: translate('crm.status', 'Status'), alignRight: false },
                    { id: 'action', label: translate('crm.action', 'Action'), alignRight: false },
                  ]}
                  rowCount={crmAccounts.length}
                  isShowCheckbox={false}
                />
                <TableBody>
                  {crmAccounts.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, i) => (
                    <TableRow hover key={i}>
                      <StyledComponent.StyledTableCell>
                        <Stack direction="row" alignItems="center" spacing={2}>
                          <Badge
                            overlap="circular"
                            style={{ color: '#ffffff' }}
                            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                            badgeContent={getAvatar(row.connected_profile_details.social_media)}
                          >
                            <Avatar
                              src={
                                row.connected_profile_details.connected_profile_image
                                  ? row.connected_profile_details.connected_profile_image
                                  : row.connected_profile_details.connected_profile_name ||
                                    row.connected_profile_details.profile_id
                              }
                              alt={
                                row.connected_profile_details.connected_profile_name
                                  ? row.connected_profile_details.connected_profile_name
                                  : row.connected_profile_details.profile_id
                              }
                              sx={{
                                alignItems: 'center',
                                justifyContent: 'center',
                                textAlign: 'center',
                                height: 40,
                                width: 40,
                                bgcolor: '#00AB55',
                              }}
                              style={{ color: '#ffffff' }}
                            />
                          </Badge>
                          <Typography variant="subtitle2" noWrap>
                            {row.connected_profile_details.connected_profile_name
                              ? row.connected_profile_details.connected_profile_name
                              : row.connected_profile_details.profile_id}
                          </Typography>
                        </Stack>
                      </StyledComponent.StyledTableCell>
                      <StyledComponent.StyledTableCell>
                        <ListItemText
                          sx={{
                            m: 0,
                            '.MuiListItemText-primary': {
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap',
                              fontSize: '0.875rem',
                            },
                            '.MuiListItemText-secondary': {
                              color: '#637381',
                              fontSize: '0.75rem',
                              textTransform: 'lowercase',
                            },
                          }}
                          primary={CommonHelper.formatDateAndTime(row.created_at, 'date')}
                          secondary={CommonHelper.formatDateAndTime(row.created_at, 'time')}
                        />
                      </StyledComponent.StyledTableCell>

                      <StyledComponent.StyledTableCell>
                        <ListItemText
                          sx={{
                            m: 0,
                            '.MuiListItemText-primary': {
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap',
                              fontSize: '0.875rem',
                            },
                            '.MuiListItemText-secondary': {
                              color: '#637381',
                              fontSize: '0.75rem',
                              textTransform: 'lowercase',
                            },
                          }}
                          primary={CommonHelper.formatDateAndTime(row.updated_at, 'date')}
                          secondary={CommonHelper.formatDateAndTime(row.updated_at, 'time')}
                        />
                      </StyledComponent.StyledTableCell>

                      <StyledComponent.StyledTableCell>
                        {PostDetailsHelper.getProfile(
                          row.created_by.name,
                          row.created_by.email,
                          row.created_by.profile_pic
                        )}
                      </StyledComponent.StyledTableCell>

                      <TableCell>
                        <StyledComponent.SwitchIcon
                          sx={{ m: 1 }}
                          checked={row.is_enabled}
                          onChange={() => handleAccountStatus(row)}
                        />
                      </TableCell>

                      <TableCell>
                        <Tooltip title="Delete">
                          <IconButton
                            size="small"
                            onClick={() => {
                              setAccountToDelete(row);
                              setConfirmOpen(true);
                            }}
                          >
                            <DeleteIcon color="error" />
                          </IconButton>
                        </Tooltip>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            <NoPostFound height={height} contentText={translate('crm.accounts_not_found', 'Accounts Not found')} />
          )}

          <TablePagination
            component="div"
            rowsPerPageOptions={[10, 15, 25]}
            count={crmAccounts.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />

          <ConfirmationDialog
            open={confirmOpen}
            onClose={() => setConfirmOpen(false)}
            onConfirm={handleDeleteAccount}
            title={translate('crm.delete_crm_account', 'Delete CRM Account')}
            message={translate('crm.confirm_delete_crm_account', 'Are you sure you want to delete this CRM account?')}
          />
        </Card>
      )}
    </>
  );
};

export default CRMAccounts;
